import angular from 'angular';

angular.module('cloudX').service('loadingAnimationInterceptor', [
  '$q',
  'loadingAnimationSvc',
  function($q, loadingAnimationSvc) {
    var xhrCreations = 0;
    var xhrResolutions = 0;

    function isLoading() {
      return xhrResolutions < xhrCreations;
    }

    function updateStatus() {
      if (isLoading()) loadingAnimationSvc.showSmallLoadingAnimation();
      else loadingAnimationSvc.hideSmallLoadingAnimation();
    }

    return {
      request: function(config) {
        xhrCreations++;
        updateStatus();
        return config;
      },
      requestError: function(rejection) {
        xhrResolutions++;
        updateStatus();
        return $q.reject(rejection);
      },
      response: function(response) {
        xhrResolutions++;
        updateStatus();
        return response;
      },
      responseError: function(rejection) {
        xhrResolutions++;
        updateStatus();
        return $q.reject(rejection);
      },
    };
  },
]);
